module.exports = __webpack_public_path__ + "static/img/12.bcd06d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/12.png
// module id = YFie
// module chunks = 0